export const ServiceModeConst = {
  VIEW: '+r',
  CREATE: '+cr',
  EDIT: '+crud',
  ADMIN: '+a',
};
